export const organizationalElements = {
  getOrganizationalElements: () => {
    const date : any = new Date();
    const key = new Date().getTime() + '_' + Math.ceil(Math.random() * 99999);
    return [
      // {
      //   group: "organizationalElementDetails",
      //   type: 'sectionHeader',
      //   name: 'sectionHeader',
      //   title: 'Section Header',
      //   elmType: 'single',
      //   dropIndex: 0,
      //   label: 'Type Section Name',
      //   description : {
      //     descriptionPlaceholder : '',
      //     descriptionText : ''
      //   },
      //   options: {
      //     width: '100%',
      //     defaultValue: '',
      //     required: false,
      //     dataType: 'string',
      //     pattern: '',
      //     placeholder: '',
      //     disabled: false,
      //   },
      //   key: key + '_sectionHeader',
      //   model:
      //     "sectionHeader" +
      //     "_" +
      //     new Date().getTime() +
      //     "_" +
      //     Math.ceil(Math.random() * 99999),
      //   rules: [],
      //   isDrag: true,
      //   isEditable: false,
      //   required: false,
      //   counter: 0,
      // },
      {
        group: 'organizationalElementDetails',
        type: 'sectionHeader',
        name: 'textAreaLongQuestion',
        title: 'Type Section Name',
        dropIndex: 0,
        elmType: 'single',
        label: 'Type Section Name',
        leftSideTitle: 'Section Header',
        options: {
          width: '100%',
          defaultValue: '',
          required: false,
          dataType: 'string',
          pattern: '',
          placeholder: 'Type description here',
          disabled: false,
        },
        key: key + '_textAreaLongQuestion',
        model:
          'textAreaLongQuestion' +
          '_' +
          new Date().getTime() +
          '_' +
          Math.ceil(Math.random() * 99999),
        rules: [],
        isDrag: true,
        isEditable: false
      },
      {
        group: 'organizationalElementDetails',
        type: 'dividerLine',
        name: 'dividerLine',
        title: 'Divider Line',
        leftSideTitle: 'Divider Line',
        elmType: 'single',
        dropIndex: 0,
        options: {
          width: '100%',
          defaultValue: '',
          required: false,
          dataType: 'string',
          pattern: '',
          placeholder: '',
          disabled: false,
        },
        key: key + '_dividerLine',
        model:
          'dividerLine' +
          '_' +
          new Date().getTime() +
          '_' +
          Math.ceil(Math.random() * 99999),
        rules: [],
        isDrag: true,
        isEditable: false,
        required: false,
      }
    ];
  }
};